import React from 'react';
import { Box, Button} from '@mui/material';
import MessageItem from './MessageItem';

const MessageList = ({ messages, colors, avatar, callbackClickAction, buttonCallMe, buttonAskForHuman, showHumanButton}) => {
  return (
    <>
      <Box sx={{ flexGrow: 1, padding: 2, overflowY: 'auto' }} id="messagesBox">
        {messages.map((msg, index) => (
          <MessageItem key={index} msg={msg} colors={colors} avatar={avatar} />
        ))}
      </Box>


        <Box>
          <Button sx={{backgroundColor:colors.secondary.backgroundColor,alignSelf:'flex-start', marginLeft:2,fontSize:'1.1vh'}} variant="contained" onClick={callbackClickAction}>
            {buttonCallMe}
          </Button>

          {showHumanButton && <Button sx={{backgroundColor:colors.secondary.backgroundColor, marginLeft:2,fontSize:'1.1vh'}} variant="contained" onClick={callbackClickAction}>
            {buttonAskForHuman}
          </Button>}
        </Box>
      
    </>
  );
};

export default MessageList;